import React, { useEffect, useState } from 'react';
import { Calendar, ChevronRight, Share2, ExternalLink } from 'lucide-react';
import Navbar from './Navbar';
import Footer from './Footer';
import RegisterModal from './RegisterModal';

const NewsPage = () => {
    const [news, setNews] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalType, setModalType] = useState('student');

    useEffect(() => {
        const fetchNews = async () => {
            try {
                // Determine API URL based on environment
                const apiUrl = import.meta.env.VITE_API_URL || 'https://m1wfhwazrd.execute-api.us-east-1.amazonaws.com/prod';
                const response = await fetch(`${apiUrl}/news`);

                if (!response.ok) {
                    throw new Error('Falha ao carregar notícias');
                }

                const data = await response.json();
                setNews(data.items || []);
            } catch (err) {
                console.error('Erro ao buscar notícias:', err);
                setError('Não foi possível carregar as últimas notícias. Tente novamente mais tarde.');
            } finally {
                setLoading(false);
            }
        };

        fetchNews();
    }, []);

    const openModal = (type) => {
        setModalType(type);
        setIsModalOpen(true);
    };

    return (
        <div className="news-page">
            <Navbar onRegister={openModal} />

            <div className="news-hero">
                <h1>Notícias e Atualizações</h1>
                <p>Acompanhe as últimas novidades sobre a CNH, Contran e legislação de trânsito.</p>
            </div>

            <div className="container news-container">
                {loading ? (
                    <div className="loading-state">
                        <div className="spinner"></div>
                        <p>Carregando notícias...</p>
                    </div>
                ) : error ? (
                    <div className="error-state">
                        <p>{error}</p>
                    </div>
                ) : news.length === 0 ? (
                    <div className="empty-state">
                        <p>Nenhuma notícia encontrada no momento.</p>
                    </div>
                ) : (
                    <div className="news-grid">
                        {news.map((item) => (
                            <article key={item.id} className="news-card glass-panel">
                                <div className="news-meta">
                                    <span className="news-source">{item.source || 'AutoMestre'}</span>
                                    <span className="news-date">
                                        <Calendar size={14} />
                                        {new Date(item.publishedAt).toLocaleDateString('pt-BR')}
                                    </span>
                                </div>
                                <h2>{item.title}</h2>
                                <p className="news-summary">{item.summary}</p>
                                <div className="news-actions">
                                    <a
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn-read-more"
                                    >
                                        Ler completa <ExternalLink size={16} />
                                    </a>
                                    <button className="btn-share" title="Compartilhar">
                                        <Share2 size={18} />
                                    </button>
                                </div>
                            </article>
                        ))}
                    </div>
                )}
            </div>

            <Footer />
            <RegisterModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                initialType={modalType}
            />
        </div>
    );
};

export default NewsPage;
